// Import VueRouter
import VueRouter from 'vue-router'

// Import pages

import Home from '../pages/Home'
import Academic from '../pages/Academic'
import Learning from '../pages/Learning'
import Blog from '../pages/Blog'

const router = new VueRouter({
    // mode: "history",
    routes:[
        {
            // Home Page
            name: 'Home',
            component: Home,
            path: '/home',
            meta: {
                sections: [
                    { id: 'short-intro', name:'Introduction'},
                    { id: 'about', name:'About'},
                    { id: 'education', name:'Education'},
                    { id: 'skills', name:'Skills'},
                    { id: 'timetable', name:'Timetable'},
                ]
            }
        },
        {
            // Academic Page
            name: 'Academic',
            component: Academic,
            path: '/academic',
            meta: {
                sections: [
                    { id: 'cuhk', name: 'CUHK' },
                    { id: 'dse', name: 'DSE' },
                ]
            }
        },
        {
            // Learning Page
            name: 'Learning',
            component: Learning,
            path: '/learning',
            meta: {
                sections: [
                    { id: 'learning-timeline', name: 'Learning Timeline' },
                    // { id: 'course-evaluation', name: 'Course Evaluations' },
                    { id: 'learning-project', name: 'Projects' },
                ]
            }
        },
        {
            // Blog Page
            name: 'Blog',
            component: Blog,
            path: '/blog',
        },

    ],
    scrollBehavior (to, from, savedPosition) {
        if(savedPosition){
            return savedPosition
        }else{
            return {x: 0, y: 0}
        }
    }
})

router.beforeEach((to, from, next) => {
    if(to.name === 'Blog'){
        window.location.href = 'https://donaldlamnl.github.io/myBlog/'
    }else{
        next()
    }
})

export default router